import React from 'react';
import PropTypes from 'prop-types';
import { Handle, Range, SliderTooltip } from 'rc-slider';
import 'rc-slider/assets/index.css';


export default function PriceFilter({ initValues, onPriceChange, minimumPrice, maxPrice }) {

  const handle = props => {
    const { value, dragging, index, ...restProps } = props;

    return (
      <SliderTooltip
        prefixCls="rc-slider-tooltip"
        overlay={`${value} €`}
        visible={dragging}
        placement="top"
        key={index}
      >
        <Handle value={value} {...restProps} />
      </SliderTooltip>
    );
  };

  return (
    <div className="w-5/6 pl-6">
      <p className="text-orange-dark text-bold font-semibold text-sm md:text-base">Prix</p>
      <>
        <div className="m-2 text-orange-dark">
          <Range
            marks={{
              0: {
                style: {
                  border: "0.25px solid #E8E8E8",
                  borderRadius: "5px",
                  padding: "0.25em 0.5em",
                  marginLeft: "10px",
                  fontSize: "15px",
                  width: "fit-content",
                  color: "#000000",
                  cursor: 'default',
                },
                label: `${minimumPrice ? minimumPrice : "0"} €`,
              },
              500: {
                style: {
                  border: "0.25px solid #E8E8E8",
                  borderRadius: "5px",
                  padding: "0.25em 0.5em",
                  fontSize: "15px",
                  width: "fit-content",
                  color: "#000000",
                  cursor: 'default',
                },
                label: `${maxPrice ? maxPrice : "300"} €`,
              },
            }}
            min={0}
            max={500}
            defaultValue={[0, 300]}
            tipFormatter={value => `$ ${value}`}
            tipProps={{
              placement: "top",
              visible: true
            }}
            onChange={onPriceChange}
            trackStyle={[{ backgroundColor: '#F5B091' }]}
            handleStyle={[{ borderColor: '#F5B091' }, { borderColor: '#F5B091' }]}
          />
        </div>
      </>
    </div>
  )
};


PriceFilter.propTypes = {
  onPriceChange: PropTypes.func,
  initValues: PropTypes.array
};
